
interface CTASectionProps {
  onNavigate: (sectionId: string) => void;
}

export default function CTASection({ onNavigate }: CTASectionProps) {
  return (
    <section className="relative py-16 md:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/dad0762007e5dcd5d641a1389de4f543.jpg"
          alt="Roma panoramica"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2d3e40]/90 via-[#2d3e40]/80 to-[#2d3e40]/70"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-8 text-center">
        <div className="flex items-center justify-center gap-3 mb-4 md:mb-6">
          <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
          <span className="font-montserrat text-[10px] md:text-[11px] uppercase tracking-[3px] md:tracking-[4px] text-[#6b8e7f]">
            Inizia il Tuo Progetto
          </span>
          <div className="w-8 h-[1px] bg-[#6b8e7f]"></div>
        </div>

        <h2 className="font-playfair text-[32px] md:text-[56px] font-bold text-white leading-[1.15] max-w-[700px] mx-auto">
          Pronti a Costruire il Futuro{' '}
          <em className="text-[#8fb5a3] not-italic">Sostenibile</em>?
        </h2>

        <p className="font-montserrat text-[13px] md:text-[16px] text-white/60 mt-4 md:mt-6 max-w-[550px] mx-auto leading-[1.8]">
          Ogni grande progetto inizia con una visione. Contattateci per trasformare la
          vostra idea in un&apos;architettura che respira.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-5 mt-8 md:mt-12">
          <a
            href="mailto:studio@marcoincitti.com"
            className="font-montserrat text-[12px] md:text-[13px] uppercase tracking-[2px] bg-[#6b8e7f] text-white px-8 md:px-10 py-3.5 md:py-4 rounded-lg hover:bg-[#5a7d6e] transition-all duration-400 cursor-pointer whitespace-nowrap inline-flex items-center gap-3"
          >
            <i className="ri-mail-line text-lg"></i>
            Contattaci
          </a>
          <button
            onClick={() => onNavigate('progetti')}
            className="font-montserrat text-[12px] md:text-[13px] uppercase tracking-[2px] text-white border border-white/30 px-8 md:px-10 py-3.5 md:py-4 rounded-lg hover:bg-white/10 hover:border-white/50 transition-all duration-400 cursor-pointer whitespace-nowrap"
          >
            Vedi i Progetti
          </button>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-12 mt-10 md:mt-16">
          {[
            { icon: 'ri-shield-check-line', text: 'Certificazione LEED' },
            { icon: 'ri-award-line', text: 'Passivhaus Certified' },
            { icon: 'ri-leaf-line', text: 'Green Building EU' },
            { icon: 'ri-global-line', text: 'Bio-Architettura Italia' },
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2">
              <i className={`${badge.icon} text-[#8fb5a3] text-base md:text-lg`}></i>
              <span className="font-montserrat text-[10px] md:text-[11px] text-white/40 uppercase tracking-[1px]">
                {badge.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
